import { render, staticRenderFns } from "./PlanTemplate.vue?vue&type=template&id=8944d796&scoped=true&"
import script from "./PlanTemplate.vue?vue&type=script&lang=js&"
export * from "./PlanTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PlanTemplate.vue?vue&type=style&index=0&id=8944d796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8944d796",
  null
  
)

export default component.exports